import { apiRequest } from '../../ConversationPage/apis/client';

import { DatevRuleset, UpsertDatevRulesetRequest } from './types';

// Get the DATEV ruleset for authenticated user
export const getDatevRuleset = async (
  token: string
): Promise<DatevRuleset | null> => {
  return apiRequest<DatevRuleset | null>({
    endpoint: '/datev-rulesets',
    method: 'GET',
    token,
  });
};

// Create or update the DATEV ruleset
export const upsertDatevRuleset = async (
  data: UpsertDatevRulesetRequest,
  token: string
): Promise<DatevRuleset> => {
  return apiRequest<DatevRuleset>({
    endpoint: '/datev-rulesets',
    method: 'POST',
    body: data,
    token,
  });
};

// Delete the DATEV ruleset
export const deleteDatevRuleset = async (
  token: string
): Promise<{ message: string }> => {
  return apiRequest<{ message: string }>({
    endpoint: '/datev-rulesets',
    method: 'DELETE',
    token,
  });
};
